<template>
  <div>
    <TriangleHeader :title="$t('Know more about ardakan glass!')"
    />
<!--    <h5 class="mt-12 font-weight-bold text-center">-->
<!--      {{$t('faq_description')}}-->
<!--    </h5>-->

    <div class="mt-12 font-weight-bold text-center w-50 mx-auto" v-html="$t('faq_description')"/>
    <loading style="margin-top: 200px!important;" v-if="loading"/>
    <!--  header-->
    <div v-else>
      <!--  FAQ-->
      <section>
        <div style="width: 700px;margin: auto" class="mt-10 pb-6 text-center">
          <!--        <h1>{{ $t('faq-title') }}</h1>-->
          <!--        <h5>{{ $t('faq-subtitle') }}</h5>-->
        </div>
        <div class="my-6 ma-auto"

             :style="$vuetify.breakpoint.smAndDown?'width:100%':'width:800px'">


          <v-list>
            <v-list-group
                v-for="(item,index) in faq.topics" :key="i"
                :class="[
                    model===index?'border':''
                ]"
                 append-icon="">
              <v-icon slot="prependIcon" large color="#FCC300" style="color: #FCC300!important;">mdi-menu-down</v-icon>
              <template v-slot:activator>
                <v-list-item-content @click="expandList(index)">
                  <h4 class="font-weight-bold faq-title">{{ item.title }}</h4>
                </v-list-item-content>
              </template>
              <v-list-item>
                <v-row>
                  <v-col class="pr-2 mt-3" v-html="item.details" cols="12">

                  </v-col>
                </v-row>
              </v-list-item>

            </v-list-group>
          </v-list>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import {GET_FAQ} from "../../../store/aboutFaq/action_type";
import {mapState} from "vuex";
import TriangleHeader from "../../../components/triangle_header/TriangleHeader";

export default {
  name: "FAQ-page",
  components: {TriangleHeader},
  data() {
    return {
      model: null,
      aboutQuestionsLists: [
        {
          id: 1,
          question: 'Has SageGlass technology been tested by an independent body? What is its level of durability?',
          answer: ' La technologie SageGlass a subi des essais de performance et de durabilité extrêmement rigoureux, réalisés par des organismes externes indépendants comme le Département de l’Énergie des États-Unis et les leaders de l’industrie de la fabrication du verre et verrières. Les vitrages isolants SageGlass ont été les premiers produits à obtenir la certification ASTM E-2141-06 (Méthodes d’essai standard pour l’évaluation de la durabilité des revêtements électrochromes absorbants sur les vitrages isolants étanches).\n' +
              'La technologie SageGlass a résisté à plus de 100 000 cycles d’essais accélérés de durabilité environnementale, soit le double des standards d’essais, ce qui reviendrait à actionner une fenêtre neuf fois par jour, 365 jours par an, pendant 30 ans, selon le National Renewable Energy Laboratory du Département de l’Énergie.'
        },
        {
          id: 2,
          question: '',
          answer: ''
        },
        {
          id: 3,
          question: '',
          answer: ''
        },
        {
          id: 4,
          question: '',
          answer: ''
        },
        {
          id: 5,
          question: '',
          answer: ''
        },

      ]
    }
  },
  created() {
    this.$store.dispatch(`aboutFaq/${GET_FAQ}`)
  },
  computed: {
    ...mapState({
      faq: state => state.aboutFaq.faq,
      loading: state => state.aboutFaq.loading
    })
  },
  methods:{
    expandList(index){
      if (this.model ===index){
        this.model=null;
      }else{
        this.model =index;
      }
    }
  }
}
</script>

<style scoped>

.faq-title:hover{
  color: #FCC300;
}
.border {
  border-bottom: 5px solid #FCC300;
  padding-bottom: 16px;
  border-top: 5px solid #FCC300;
}

.faq-header {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 200px;
  background: #f2c303 url("../../../assets/images/sunburst.png");
}

.faq-header-bottom-border {
  position: absolute;
  bottom: -22px;
  width: 100%;
}

</style>